// extracted by mini-css-extract-plugin
module.exports = {"infoButton":"InfoButton_infoButton__yggd4"};